import { render, staticRenderFns } from "./Basket.vue?vue&type=template&id=8d5fb388"
import script from "./Basket.vue?vue&type=script&lang=js"
export * from "./Basket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/home/runner/work/platform/platform/packages/client/src/components/elements/typography/heading/Heading.vue').default,Notification: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/notification/Notification.vue').default,Currency: require('/home/runner/work/platform/platform/packages/client/src/components/elements/financial/currency-display/Currency.vue').default,Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default})
